export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10066.aa04aa06.jpg";